import { FC } from "react";
import Link from "next/link";
import ChevronRightIcon from "@heroicons/react/solid/ChevronRightIcon";
import { useTranslation } from "next-i18next";

import { capitalize } from "@utils/capitalize";

type Breadcrumb = { name: string; path: string } | string;

interface Props {
  breadcrumbs: Breadcrumb[];
}

const BreadCrumb: FC<{ href: string; name: string }> = ({ href, name }) => (
  <span className="flex flex-row content-center space-x-1 mx-1 max-h-4">
    <Link href={href}>
      <a>{name}</a>
    </Link>
    <ChevronRightIcon className="w-4" />
  </span>
);

const BreadCrumbs: FC<Props> = ({ breadcrumbs }) => {
  const { t } = useTranslation("common");

  return (
    <div className="text-black text-sm flex flex-row flex-wrap content-center max-w-screen my-3 mx-4">
      <BreadCrumb href={"/"} name={t("breadcrumbs.landing")} />
      {breadcrumbs.slice(0, -1).map((breadcrumb, index, array) => {
        let name: string, path: string;
        if (typeof breadcrumb === "string") {
          name = path = breadcrumb;
        } else {
          ({ name, path } = breadcrumb);
        }
        const prefix = !path[0].startsWith("/") ? "/" : "";
        const href = `${prefix}${array
          .slice(0, index + 1)
          .map((bc) => (typeof bc === "string" ? bc : bc.path))
          .join("/")}`;
        return <BreadCrumb key={href} href={href} name={capitalize(name)} />;
      })}
      <span className="first-letter:capitalize max-w-[35vw] truncate">
        {breadcrumbs[breadcrumbs.length - 1]}
      </span>
    </div>
  );
};

export default BreadCrumbs;
